import { APP_TYPE_PREFIX } from '../../utils/routines'

const createAction = type => payload => ({ type, payload })

export const SET_TOKEN = `${APP_TYPE_PREFIX}/Login/SET_TOKEN`
export const setToken = createAction(SET_TOKEN)

export const ON_TOKEN_EXPIRED = `${APP_TYPE_PREFIX}/Login/ON_TOKEN_EXPIRED`
export const onTokenExpired = createAction(ON_TOKEN_EXPIRED)

export const LOGOUT = `${APP_TYPE_PREFIX}/Login/LOGOUT`
export const logout = createAction(LOGOUT)

export const START_EXPIRES_TIMER = `${APP_TYPE_PREFIX}/Login/EXPIRES_TIMER/START`
export const startExpiresTimer = createAction(START_EXPIRES_TIMER)

export const CANCEL_EXPIRES_TIMER = `${APP_TYPE_PREFIX}/Login/EXPIRES_TIMER/CANCEL`
export const cancelExpiresTimer = createAction(CANCEL_EXPIRES_TIMER)
